import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WheelSpinGameSelectorComponent } from './wheel-spin-game-selector/wheel-spin-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { WheelSpinGameCoreService } from './wheel-spin-game-core.service';

@NgModule({
  declarations: [WheelSpinGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [WheelSpinGameCoreService],
  exports: [WheelSpinGameSelectorComponent],
})
export class WheelSpinGameCoreModule {}
